import type { TabProps } from '../tab/tab';
import styles from './tabs-panel.module.css';

export interface TabsPanelProps {
  children: React.ReactElement<TabProps>[];
  tab: string;
}

export function TabsPanel(props: TabsPanelProps) {
  return (
    <>
      {props.children.map((child, index) => {
        if (child.props.name === props.tab) {
          return (
            <div className={styles.panel} key={index}>
              {child}
            </div>
          );
        }
        return null;
      })}
    </>
  );
}
